import React, { lazy, Suspense } from "react";

const EChartsChartLazy = lazy(() => import("./no.ssr.bar.chart"));

const WeeklyBar = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <EChartsChartLazy />
    </Suspense>
  );
};

export default WeeklyBar;
